<template>
  <div class="footer" v-if="path != 'error'  && path != 'login'">
    <div style="width:300px;margin:0 auto; padding:20px 0;">
      <a target="_blank"
        style="display:inline-block;text-decoration:none;height:20px;line-height:20px;"><img
          src="../../common/imgs/reference.png" style="float:left;" />
        <p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;">{{ websiteSessionInfo.webSiteICP }}
        </p>
      </a>
    </div>
  </div>
</template>

<script>
import globalApi from "@/common/globalApi.js";
export default {
  name: "Footer",
  data() {
    return {
      websiteSessionInfo: globalApi.gWebsiteSessionInfo,
      path: "",
    };
  },
  watch: {
    $route() {
      //监控$route
      this.path = this.$route.path.replace(/\//g, "");
    },
  },
  created() {
    //监控$route
    this.path = this.$route.path.replace(/\//g, "");
  },
  components: {},

  computed: {},

  methods: {},
};
</script>
<style lang="scss">
.footer {
  .linkWrap {
    background: rgb(233, 235, 240);
    .container {
      background: rgb(233, 235, 240);
      padding: 40px 0;
      .linkBox {
        margin: 0 auto;
        width: 1200px;
        text-align: center;
        margin-bottom: 24px;
        a {
          margin-right: 40px;
          color: #444e59;
        }
        a:last-child {
          margin-right: 0;
        }
      }
    }

    .address {
      text-align: center;
      span {
        margin-right: 40px;
      }
      span:last-child {
        margin-right: 0;
      }
    }
  }
  .infoWrap {
    background: rgb(218, 220, 224);
    .container {
      padding: 10px 0;
      background: rgb(218, 220, 224);
      .info {
        margin: 0 auto;
        width: 1200px;
        height: 50px;
        line-height: 25px;
        color: #444e59;
        text-align: center;
        font-size: 12px;
      }
      a {
        color: #444e59;
      }
    }
  }
}
</style>
